import { checkRangeByKeys } from '../../ui-kit/Calculator/rangeHelpers.js';
import { checkCreditSourceBookRowCommonParams } from './checkCreditSourceBookRowCommonParams.js';
import { DEFAULT_CREDIT_CALCULATOR_PARAMS } from './defaultCreditCalculatorParams.js';
export const getCreditCalculatorRateParams = ({ rateRows = [], userInputParams, paramsViewSettings, moneyValue, monthsValue, }) => rateRows?.find((row) => checkCreditSourceBookRowCommonParams({
    row,
    userInputParams,
    paramsViewSettings,
}) &&
    checkRangeByKeys(moneyValue, ['minSum', 'maxSum'], row) &&
    checkRangeByKeys(monthsValue, ['minMonths', 'maxMonths'], row)) || DEFAULT_CREDIT_CALCULATOR_PARAMS;
//# sourceMappingURL=getCreditCalculatorRateParams.js.map